import React from 'react';
import { motion } from 'framer-motion';
const pains = [{
  image: 'https://cdn.magicpatterns.com/uploads/d9Zzvx4JHyEdpYiv8jM9yx/madrecocinandosolaheylloyd-image-1771691667500.png',
  alt: 'Madre cocinando sola en una cocina desordenada y cansada',
  title: 'Horas en la cocina',
  description: 'Recetas complejas que requieren tiempo que no tenés, solo para que terminen en la basura.',
  gradient: 'from-orange-500 to-orange-400',
  border: 'border-orange-300',
  badge: 'bg-orange-500'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/pUY1LRq9by5xqNy73taiKi/ninollorandoheylloyd-image-1771690495535.png',
  alt: 'Niño llorando y rechazando la comida',
  title: 'Rechazo inmediato',
  description: 'Si ven un trocito verde o sienten una textura extraña, el plato queda intacto.',
  gradient: 'from-violet-600 to-violet-400',
  border: 'border-violet-300',
  badge: 'bg-violet-500'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/dnrqM7z8NnxVcB8FRzRR2g/madrecansadafinalheylloyd-image-1771692492399.png',
  alt: 'Madre cansada y frustrada sentada en la cocina desordenada',
  title: 'Culpa y frustración',
  description: 'Sentís que no están comiendo lo suficientemente sano y las vitaminas que necesitan.',
  gradient: 'from-emerald-600 to-emerald-400',
  border: 'border-emerald-300',
  badge: 'bg-emerald-500'
}];
export function PainSection() {
  return <section className="py-20 bg-gradient-to-b from-emerald-50 to-white" data-id="element-217">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-6" data-id="element-220">
            <span className="text-violet-600" data-id="element-221">Sabemos lo frustrante</span>{' '}
            <span className="text-orange-500" data-id="element-222">
              que es probar receta tras receta...
            </span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-223">
            Las soluciones de siempre fallan: tardan horas, dejan rastros
            visibles o no entienden el paladar de los chicos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-224">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} whileHover={{
          y: -8,
          scale: 1.02,
          transition: {
            type: 'spring',
            stiffness: 280,
            damping: 18
          }
        }} className={`bg-white rounded-3xl overflow-hidden shadow-lg border-2 ${pain.border} cursor-default`} data-id="element-225">
              {/* Image */}
              <div className="relative h-52 overflow-hidden" data-id="element-226">
                <img src={pain.image} alt={pain.alt} className="w-full h-full object-cover" data-id="element-227" />
                <div className={`absolute inset-0 bg-gradient-to-t ${pain.gradient} opacity-30`} data-id="element-228" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-229">
                <div className={`inline-block ${pain.badge} text-white text-xs font-extrabold uppercase tracking-wider px-3 py-1 rounded-full mb-3`} data-id="element-230">
                  Problema #{index + 1}
                </div>
                <h3 className={`text-xl font-extrabold mb-3 bg-gradient-to-r ${pain.gradient} bg-clip-text text-transparent`} data-id="element-231">
                  {pain.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-232">
                  {pain.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}